import { useEffect, useState } from "react";
import { useWishlist } from "@/context/WishlistContext";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Link } from "react-router-dom";

export default function WishlistPage() {
  const { ids } = useWishlist();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (ids.length === 0) { setProducts([]); return; }
    api.get("/products").then((r) => setProducts(r.data.filter((p) => ids.includes(p.id))));
  }, [ids]);

  return (
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16" data-testid="wishlist-page">
      <p className="label-eyebrow mb-3">Saved</p>
      <h1 className="font-serif text-5xl tracking-tighter mb-12">Wishlist ({ids.length})</h1>

      {products.length === 0 ? (
        <div className="text-center py-16">
          <p className="text-[#6A747D] mb-6">Your wishlist is empty.</p>
          <Link to="/shop" className="btn-gold">Browse Products</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-8 gap-y-12">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
